<div class="cs-wrap">
	<button type="button" class="cs-trigger" (click)="toggleOpen()" [class.active]="isOpen" aria-label="Columns">
		<i class="bx bx-cog fs-18"></i>
	</button>

	<div class="cs-panel" *ngIf="isOpen">
		<div class="cs-search">
			<input type="text" [(ngModel)]="search" placeholder="Search" class="cs-search-input" />
		</div>

		<div class="cs-label">Columns</div>

		<div class="cs-list">
			<label class="cs-item" *ngFor="let column of filteredColumns; trackBy: trackByProp">
				<input type="checkbox" [checked]="column.visible" (change)="toggleColumn(column)" />
				<span class="cs-item-name">{{ column.name }}</span>
			</label>

			<div class="cs-empty" *ngIf="!filteredColumns.length">No columns found.</div>
		</div>
		<div class="cs-footer">
			<button type="button" class="cs-footer-btn" (click)="selectAll()">Select all</button>
			<button type="button" class="cs-footer-btn" (click)="resetToDefault()">Reset to default</button>
		</div>
	</div>
</div>
